import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AttendanceReportsLayer from "../components/attendance/AttendanceReportsLayer";

const AttendanceReportsPage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Attendance Reports" />
        <AttendanceReportsLayer />
      </MasterLayout>
    </>
  );
};

export default AttendanceReportsPage;
